module.exports = __webpack_public_path__ + "static/media/crdt.be03a85d.svg";